module.exports = __webpack_public_path__ + "assets/img/kv-ae9c80d2.jpg";